import Vue from 'vue'
import {
    Dialog,
    Autocomplete,
    Button,
    Aside,
    Container,
    DatePicker,
    Main,
    Menu,
    MenuItem,
    Table,
    TabPane,
    TableColumn,
    Header,
    Row,
    Col,
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Avatar,
    Cascader,
    Alert,
    InfiniteScroll,
    Backtop,
    Image,
    Loading,
    Message,
    Pagination,
    Popover,
    Tooltip,
    Tabs,
    RadioGroup,
    Radio,
    Switch,
    Dropdown,
    DropdownMenu,
    DropdownItem
} from 'element-ui'
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }
Vue.use(Dialog)
Vue.use(Autocomplete)
Vue.use(Button)
Vue.use(Aside)
Vue.use(Container)
Vue.use(DatePicker)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Table)
Vue.use(TabPane)
Vue.use(TableColumn)
Vue.use(Header)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Avatar)
Vue.use(Cascader)
Vue.use(Alert)
Vue.use(InfiniteScroll)
Vue.use(Backtop)
Vue.use(Image)
Vue.use(Loading.directive)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Tabs)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Switch)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.prototype.$message = Message